import { useAuth } from '@on3/ui-lib/src/contexts/AuthProvider';
import { databaseUrl } from '@on3/ui-lib/utils/api';
import { FeedList } from 'components/Headlines/ArticleFeed/FeedList';
import { InternalMenu, NilInternalMenu } from 'components/Menu/InternalMenu';
import { SportTab } from 'components/Menu/SportTab';
import { DealsHomeModule } from 'components/Nil/DealsHomeModule';
import { SocialConnect } from 'components/Social/SocialConnect';
import { Text } from 'components/UI/Typography/Text';
import type { INilCollectiveGroupPageProps } from 'pages/nil/collectives/[collectiveGroup]';
import { useMemo } from 'react';

import { CollectiveGroupModule } from './CollectiveGroupModule';
import { FoundersModule } from './FoundersModule';
import styles from './NilCollectiveGroup.module.scss';

export const NilCollectiveGroup = ({
  collective,
  articles,
  nilDeals,
}: INilCollectiveGroupPageProps) => {
  const {
    name,
    sports,
    defaultAsset,
    socialAsset,
    websiteUrl,
    websiteName,
    youtubeHandle,
    tikTokHandle,
    instagramHandle,
    linkedInHandle,
    twitterHandle,
    description,
    slug,
    organization,
  } = collective || {};
  const showNews = articles?.list && articles.list.length > 0;
  const showDeals = nilDeals?.list && nilDeals?.list?.length > 0;
  const { hasRdbLevel2Access } = useAuth();

  const collectiveNewsViewAll = useMemo(() => {
    return [
      {
        url: `nil/collectives/${slug?.toLowerCase()}/news/`,
        text: 'View All',
        title: 'Football News',
      },
    ];
  }, [slug]);

  return (
    <div>
      {hasRdbLevel2Access() && (
        <a
          href={`${databaseUrl}/nil/collectivegroup/${slug?.toLowerCase()}/edit/`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Edit
        </a>
      )}
      <header className={styles.header}>
        <Text variant="h1">
          {`${name} - ${organization?.fullName} Collective` ||
            'NIL Collective Group'}
        </Text>
      </header>
      <InternalMenu className={styles.internalMenu} list={NilInternalMenu} />
      {collective && <CollectiveGroupModule data={collective} />}
      <div className={styles.founderDescritionWrapper}>
        {collective && <FoundersModule data={collective} />}
        <Text className={styles.description}>{description}</Text>
      </div>
      <div className={styles.sportSocialWrapper}>
        {sports && <SportTab sports={sports} />}

        <SocialConnect
          defaultAsset={socialAsset ?? defaultAsset}
          instagramHandle={instagramHandle}
          linkedInHandle={linkedInHandle}
          name={name}
          tikTokHandle={tikTokHandle}
          twitterHandle={twitterHandle}
          websiteName={websiteName}
          websiteUrl={websiteUrl}
          youtubeHandle={youtubeHandle}
        />
      </div>

      <div className={styles.columnsContainer}>
        <div className={styles.modules}>
          {showDeals && (
            <DealsHomeModule
              list={nilDeals.list}
              viewAllLink={`/nil/collectives/${slug?.toLowerCase()}/deals/`}
            />
          )}
        </div>
        {showNews && (
          <FeedList
            list={articles.list?.slice(0, 10)}
            section="News"
            viewAllLinks={collectiveNewsViewAll}
          />
        )}
      </div>
    </div>
  );
};
